import React from "react";

// Two-toned MedexOVA lockup — Medex = forest green, OVA = OVA purple.
// Use wherever we mention the partnership brand.
export default function MedexOVA({ className = "", size = "inherit" }) {
  return (
    <span className={`whitespace-nowrap font-semibold ${className}`} style={{ fontSize: size }} data-testid="medexova-wordmark">
      <span className="text-[#16A34A]">Medex</span>
      <span className="text-ova">OVA</span>
    </span>
  );
}

// Compact dot pair for visual treatment in badges/chips
export function MedexOvaDots({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className="h-2 w-2 rounded-full bg-forest"></span>
      <span className="h-2 w-2 rounded-full bg-ova"></span>
    </span>
  );
}
